import { useActiveChatId } from "@/lib/hooks/useActiveChatId";
import { useActiveFileName } from "@/lib/hooks/useActiveFileName";
import { useActiveVersionNumber } from "@/lib/hooks/useActiveVersionNumber";
import { cn } from "@/lib/utils";
import { useMessageStore } from "@/state/stores/messageStore";
import { Link } from "@tanstack/react-router";
import { File } from "lucide-react";
import { useShallow } from "zustand/react/shallow";

export function FileList() {
  const chatId = useActiveChatId();
  const versionNumber = useActiveVersionNumber();
  const currentFileName = useActiveFileName();

  const allFiles = useMessageStore(
    useShallow((state) => {
      const versionInfo = Object.values(state.versionInformation).find(
        (info) => info.version === versionNumber,
      );

      if (!versionInfo) {
        return [];
      }

      // Get all files, exclude deployment status files, and sort by filename
      const files = versionInfo.files
        .filter((file) => !file.filename.startsWith("Deploy Status: "))
        .sort((a, b) => a.filename.localeCompare(b.filename))
        .map((file) => file.filename);

      return files;
    }),
  );

  if (!chatId || allFiles.length === 0) {
    return null;
  }

  return (
    <ul className="flex flex-col gap-2 bg-muted p-2 h-full overflow-y-auto">
      {allFiles.map((filename) => (
        <li key={filename}>
          <Link
            to="/codegen/$chatId/attachments/$versionNumber"
            params={{
              chatId,
              versionNumber: `v${versionNumber}`,
            }}
            search={{ tab: "code", file: filename }}
            className={cn(
              "font-mono text-xs grid grid-cols-[auto_1fr] gap-2 items-center px-2 py-1 hover:bg-muted-foreground/20 rounded-sm truncate",
              filename === currentFileName &&
                "bg-muted-foreground/20 hover:bg-muted-foreground/30",
            )}
          >
            <File className="w-4 h-4" />
            {filename}
          </Link>
        </li>
      ))}
    </ul>
  );
}
